export default function residualValueManagementColumnSpecification(config) {
    const { fmvDetails = [] } = config.data;
    let result = {};
    let tableData = [];

    fmvDetails.forEach((fmvDetails, index) => {
        let row = [];
        const rowId = fmvDetails.fmvDetailsId;
        config.columns.forEach(column => {
            let columnValue = "";
            let isDisabled = false;
            let customEventHandler = null;
            let isOverflowingContent = false;
            let columnValueData = null;
            let displayAsIs = column.data.displayInBodyAsIs;

            if (column.data.displayInBodyAs == "string") {
                if (column.id === "dataProvider") {
                    displayAsIs = true;
                    columnValue = fmvDetails.dataProvider;
                }
                else if (column.id === "countriesWithResidualValues") {
                    displayAsIs = true;
                    columnValue = fmvDetails.countriesWithResidualValues || "";
                } else if (column.id === "assetsQuoted") {
                    displayAsIs = true;
                    columnValue = fmvDetails.assetsQuoted || "";
                } else if (column.id === "assetsSharedWithDataProvider") {
                    displayAsIs = true;
                    columnValue = fmvDetails.assetsSharedWithDataProvider || "";
                } else if (column.id === "assetResidualValue") {
                    displayAsIs = true;
                    columnValue = fmvDetails.assetResidualValue || "";
                } else if (column.id === "currency") {
                    displayAsIs = true;
                    columnValue = fmvDetails.currency || "";
                } else if (column.id === "totalResidualValue") {
                    displayAsIs = true;
                    columnValue = (fmvDetails.totalResidualValue && fmvDetails.totalResidualValue !== "0.0" && fmvDetails.totalResidualValue !== "0")
                        ? fmvDetails.totalResidualValue
                        : "";
                } else if (column.id === "refreshTimestamp") {
                    displayAsIs = true;
                    columnValue = fmvDetails.refreshTimestamp || "";
                }
            }
            else if (column.data.displayInBodyAs == "downloadIcon" && column.id == "fileName") {
                let filename = fmvDetails.fileName.split('_').slice(1).join('_');

                displayAsIs = true;
                columnValue = { labelId: filename, displayLabel: true, disabled: isDisabled } || "";
                customEventHandler = config.bodyButtonsHandler.handleFMVDownload ? event => config.bodyButtonsHandler.handleFMVDownload(event, rowId, fmvDetails.fileName) : null;
            }
            else if (column.data.displayInBodyAs == "button") {
                displayAsIs = true;
                columnValue = { labelId: "", type: "icon", theme: "drs-icon", endIcon: "refresh", disabled: isDisabled } || "";
                customEventHandler = config.bodyButtonsHandler.handleFMVRefresh ? event => config.bodyButtonsHandler.handleFMVRefresh(event, rowId) : null;
            }

            row.push({
                [column.id]: {
                    id: column.id + "|" + rowId,
                    type: column.data.displayInBodyAs,
                    value: columnValueData || columnValue,
                    width: column.width,
                    disabled: isDisabled,
                    displayAsIs: displayAsIs,
                    isOverflowingContent: isOverflowingContent,
                    showInMobileViewAs: column.showInMobileViewAs,
                    clickHandler: customEventHandler
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    });


    result['columns'] = config.columns;
    result['data'] = tableData;

    return result;
}